import { render, staticRenderFns } from "./BAnalyst.vue?vue&type=template&id=95e64000"
import script from "./BAnalyst.vue?vue&type=script&lang=js"
export * from "./BAnalyst.vue?vue&type=script&lang=js"
import style0 from "./BAnalyst.vue?vue&type=style&index=0&id=95e64000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports